import type { ReactNode } from 'react'
import React from 'react'

import * as S from './styled'

type Props = {
  children: ReactNode
}

export const OrderedList = ({ children }: Props) => {
  return <S.OrderedList>{children}</S.OrderedList>
}

OrderedList.Item = S.OrderedListItem
